import { render, staticRenderFns } from "./HeroCentrum.vue?vue&type=template&id=3f47beaf&scoped=true"
import script from "./HeroCentrum.vue?vue&type=script&lang=js"
export * from "./HeroCentrum.vue?vue&type=script&lang=js"
import style0 from "./HeroCentrum.vue?vue&type=style&index=0&id=3f47beaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f47beaf",
  null
  
)

export default component.exports